import { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { SilhouettesContainer } from './styled'
import silhouetteImgS from '../images/Parallax2_S.webp'
import silhouetteImgM from '../images/Parallax2_M.webp'
import silhouetteImgL from '../images/Parallax2_L.webp'
const Silhouettes = () => {
  const ref = useRef(null)
  const [isDesktop, setIsDesktop] = useState<boolean>(false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })
  const height = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['0%', '100%', '100%']
  )
  const blur = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['blur(5px)', 'blur(0px)', 'blur(0px)']
  )
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024)
    }

    handleResize() // set initial value
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })
  return (
    <SilhouettesContainer ref={ref}>
      <motion.div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          filter: !isDesktop ? blur : 'none',
          overflow: !isDesktop ? 'hidden' : 'visible',
          height: !isDesktop ? height : 'auto',
        }}
      >
        <picture>
          <source
            srcSet={silhouetteImgS}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <source
            srcSet={silhouetteImgM}
            media="(max-width: 1280px)"
            type="image/webp"
          />
          <img src={silhouetteImgL} alt="" />
        </picture>
      </motion.div>
    </SilhouettesContainer>
  )
}
export default Silhouettes
